import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the CoCountdownComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-countdown',
  templateUrl: 'co-countdown.html'
})
export class CoCountdownComponent {

  message: string;
  time: number = 0;
  detail: string;
  buttonLabel: string;

  constructor(private navParams: NavParams, private viewCtrl: ViewController) {
    this.message = this.navParams.data.message;
    this.time = this.navParams.data.time;
    this.detail = this.navParams.data.detail;
    this.buttonLabel = this.navParams.data.buttonLabel || 'Cancel';
    setInterval(() => {
      if (this.time === 0) {
        this.viewCtrl.dismiss({success: true}).catch(err=>{});
        return;
      }
      this.time--;
      // console.log(this.time);
    }, 1000);
  }

  cancel() {
    this.viewCtrl.dismiss({}).catch(err=>{});
  }


}



// WEBPACK FOOTER //
// ./src/components/co-countdown/co-countdown.ts